import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import SEOHead from '../../../components/SEO/SEOHead';

/**
 * Not-found page. Unknown catalogue slugs and any other path outside the
 * rewrite allowlist are served as build/404.html with HTTP 404. This is
 * the same screen the client shows if a real route has nothing to render.
 */
const NotFoundPage = ({ embedded = false }) => {
  const navigate = useNavigate();
  const path = window.location.pathname || '/';
  const body = (
    <div className="max-w-xl mx-auto px-4 py-16 text-center">
      <h1 className="text-3xl font-bold text-gray-900 mb-3">Page not found</h1>
      <p className="text-gray-600 mb-8">
        That link does not match a Fixome page. You can go home or book a service.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link to="/" className="fx-btn-primary px-5">
          Go home
        </Link>
        <button
          type="button"
          onClick={() => navigate('/booking/new')}
          className="fx-btn-secondary px-5"
        >
          Book a service
        </button>
      </div>
    </div>
  );

  return (
    <>
      <SEOHead
        title="Page not found | Fixome"
        description="This Fixome page does not exist. Book a home service in Kochi, Thiruvananthapuram, or Calicut."
        url={path}
        canonical={path}
        noindex
      />
      {embedded ? body : <MainLayout>{body}</MainLayout>}
    </>
  );
};

export default NotFoundPage;
